module.exports = __webpack_public_path__ + "img/FeesTypes.422180b9.svg";